import React from 'react';
import Button from '../../../components/Button/Button';
import Webcam from 'react-webcam';
import '../SelfieVerification.styles.scss';
import YesNoBtns from '../../../components/YesNoBtns/YesNoBtns';
import Appear from '../../../components/Appear/Appear';
import withContainer from '../../../containers/WithContainer';
import { dataURItoBlob } from '../../../utils/utils';
import classnames from 'classnames';

interface SelfieWizardProps {
  selectedImages: string[];
  exampleImages: string[];
  stepTitles: string[];
  onSelect?: (img: string) => void;
  appContainer: any;
  code: string;
}
interface SelfieWizardState {
  isCameraEnabled: boolean;
  previewImage: string;
  uploadedFile: File;
}
class SelfieWizard extends React.Component<
  SelfieWizardProps,
  SelfieWizardState
> {
  public webcamRef;

  constructor(props) {
    super(props);
    this.state = {
      isCameraEnabled: false,
      previewImage: '',
      uploadedFile: null,
    };
  }

  handleSnapshot = () => {
    const img = this.webcamRef.getScreenshot();
    this.props.onSelect(img);
    let file;
    // check if img is webcam image or uploaded image.
    if (img.search('blob:') === -1) {
      const blob = dataURItoBlob(img);
      file = new File([blob], 'imgFile', { type: 'image/jpeg' });
    }
    this.props.appContainer.step11imageUpload(file, this.props.code);
    this.setState({ isCameraEnabled: false });
  };

  handleUploadChange = async (evt: any) => {
    let file = evt.target.files[0];
    if (!file) return;
    const img = URL.createObjectURL(file);
    // this.setState({ previewImage: img, uploadedFile: file });
    this.props.onSelect(img);
    //check if img is webcam image or uploaded image.
    if (img.search('blob:') === -1) {
      const blob = dataURItoBlob(img);
      file = new File([blob], 'imgFile', { type: 'image/jpeg' });
    }
    this.props.appContainer.step11imageUpload(file, this.props.code);
  };

  handleKeep = async () => {
    const img = this.state.previewImage;
    this.props.onSelect(img);
    this.setState({ previewImage: '' });

    let file;
    //check if img is webcam image or uploaded image.
    if (img.search('blob:') === -1) {
      const blob = dataURItoBlob(img);
      file = new File([blob], 'imgFile', { type: 'image/jpeg' });
    } else {
      file = this.state.uploadedFile;
    }
    this.props.appContainer.step11imageUpload(file, this.props.code);
  };

  handleDiscard = () => {
    this.setState({ previewImage: '' });
  };

  render() {
    const { selectedImages, stepTitles, exampleImages, code } = this.props;
    const { isCameraEnabled, previewImage } = this.state;
    const currentStep = selectedImages.length;
    const splitCode = code.split('');
    return (
      <>
        <div className="has-text-grey" style={{ marginTop: '-25px' }}>
          {/* {
            true || !previewImage && currentStep < 1 && */}
          <>
            <span className="has-text-weight-semibold">{stepTitles[0]}</span>
            <br />
            Take a selfie holding up
            <span className="has-text-weight-bold">
              <span> {splitCode[0]} </span>
              <span>
                {+splitCode[0] > 1 && ' fingers '}
                {+splitCode[0] <= 1 && ' finger '}
              </span>
            </span>
            as shown below. <br />
            <small>
              <b>
                This photo will never be shared with customers. Its only for
                verification.
              </b>
            </small>
          </>
          {/* } */}
        </div>
        {/* {
          !previewImage && currentStep < 1 && */}
        <Appear
          delay={0.5}
          className="level has-margin-top-10 has-margin-bottom-0"
        >
          <div className="level-item has-text-centered">
            <figure className="image is-128x128">
              <img
                className={classnames({
                  'has-width-100': selectedImages.length,
                })}
                src={exampleImages[0]}
                alt="example image"
              />
            </figure>
          </div>
        </Appear>
        {/* } */}

        {!!previewImage && (
          <Appear>
            <div className="has-text-centered columns flex-row justify-center is-marginless">
              <div className="column is-8-mobile">
                <img
                  src={previewImage}
                  alt="Snapshot"
                  className="is-flipped-x is-hidden-touch"
                />
                <img
                  src={previewImage}
                  alt="Snapshot"
                  className="is-hidden-desktop"
                />
              </div>
            </div>

            <p className="is-size-standard has-text-centered has-margin-bottom-5 has-text-weight-bold">
              Keep this?
            </p>
            <YesNoBtns
              icons={[
                <i className="fas fa-times" />,
                <i className="fas fa-check" />,
              ]}
              isOutlined
              yesBtnClass="is-primary"
              noBtnClass="is-danger"
              yesLabel="Keep"
              noLabel="discard"
              onYes={this.handleKeep}
              onNo={this.handleDiscard}
            />
          </Appear>
        )}

        {isCameraEnabled && (
          <>
            <div className="has-margin-top-20 SelfieVerification__webcam-holder">
              <div className="level">
                <div className="level-item is-flipped-x">
                  <Webcam
                    ref={el => (this.webcamRef = el)}
                    height={350}
                    width={350}
                  />
                </div>
              </div>
              <button
                type="button"
                className="SelfieVerification__snapshot-btn"
                onClick={this.handleSnapshot}
              />
            </div>
          </>
        )}

        {!!selectedImages.length && !isCameraEnabled && (
          <div className="columns is-mobile flex-row justify-center is-marginless">
            {selectedImages.map(img => (
              <Appear
                key={img.toString()}
                className="column is-9-mobile has-padding-bottom-0"
              >
                <img
                  src={img}
                  alt="Captured Image"
                  className="is-flipped-x is-covering-container is-hidden-touch"
                />
                <img
                  src={img}
                  alt="Captured Image"
                  className="is-hidden-desktop is-covering-container"
                />
              </Appear>
            ))}
          </div>
        )}

        {!isCameraEnabled && (
          <>
            <div className="has-text-centered has-margin-top-15 is-hidden-touch">
              <Button
                color={currentStep === 1 ? 'default' : 'primary'}
                className="is-size-3 has-height-auto"
                onClick={() => this.setState({ isCameraEnabled: true })}
              >
                <i className="fas fa-camera" />
              </Button>
            </div>

            <div className="has-text-centered subtitle is-6 has-margin-top-5 is-hidden-touch">
              {currentStep === 1 ? 'Change Picture' : 'Take Picture'}
            </div>
          </>
        )}

        {/* {currentStep < 1 && */}
        <div className="level is-hidden-desktop">
          <div className="file level-item">
            <label className="file-label">
              <input
                className="file-input"
                type="file"
                name="resume"
                onChange={this.handleUploadChange}
                accept="image/*"
              />
              <span
                className={classnames({
                  'upload-button button is-full-width is-primary': !selectedImages.length,
                })}
              >
                <span className="file-label">
                  {currentStep === 1 ? 'Change Photo' : 'Upload Picture'}
                </span>
              </span>
            </label>
          </div>
        </div>
        {/* } */}

        {/* {
          currentStep === 1 &&
          <Appear delay={.5} className="has-text-centered">
            <div className="title is-5">
              Well Done!
            </div>
            <div className="subtitle is-5">
              You're now ready to roll.
            </div>
            <FormField
              label="How did you hear about us?"
              htmlFor="question"
              required
              className="has-text-left"
            >
              <input
                name="question"
                id="question"
                className="input"
                value={this.props.appContainer.state.hearUs}
                onChange={this.props.appContainer.onHearUsChange}
              />
            </FormField>
          </Appear>
        } */}
      </>
    );
  }
}

export default withContainer(SelfieWizard);
